module.exports = __webpack_public_path__ + "img/whiteout.4c843aad.png";